export function getDomain() {
    const hostName = window.location.hostname.toLowerCase()
    if (hostName.includes('localhost')) {
        return hostName
    }
    const urlParts = hostName.split('.')
    // return the parent domain
    return `.${urlParts.slice(-2).join('.')}`
}
